import { PlayerDataGQL, PlayersStatsData } from '../Api'
import { MAIN_PLL_URL } from '../Config/config'
export type PlayerSortKeys = keyof PlayersStatsData
export type PlayerInfoKeys = keyof PlayerDataGQL

export const positionArray = ['A', 'M', 'D', 'LSM', 'SSDM', 'FO', 'G']

export const positionNameToCodeMap: { [key: string]: string } = {
  Attack: 'A',
  Midfield: 'M',
  Defense: 'D',
  Faceoff: 'FO',
  Goalie: 'G',
  LSM: 'LSM',
  SSDM: 'SSDM',
}

export const allStarPositionNameToCodeMap: { [key: string]: string } = {
  Attack: 'A',
  Midfield: 'M',
  Defense: 'D',
  Faceoff: 'FO',
  Goalie: 'G',
  LSM: 'D',
  SSDM: 'M',
}

export const positionDropdown = [
  { label: 'All Positions', value: 'All Positions' },
  { label: 'A', value: 'A' },
  { label: 'M', value: 'M' },
  { label: 'D', value: 'D' },
  { label: 'FO', value: 'FO' },
  { label: 'G', value: 'G' },
  { label: 'LSM', value: 'LSM' },
  { label: 'SSDM', value: 'SSDM' },
]

export const playersToWatchList = [
  'points',
  'onePointGoals',
  'twoPointGoals',
  'assists',
  'shots',
  'causedTurnovers',
  'groundBalls',
  'touches',
]

export const statTitles: PlayerSortKeys[] = [
  'points',
  'onePointGoals',
  'twoPointGoals',
  'assists',
  'faceoffPct',
  'causedTurnovers',
  'savePct',
]

export const champSeriesStatTitles: PlayerSortKeys[] = [
  'points',
  'onePointGoals',
  'twoPointGoals',
  'assists',
  'causedTurnovers',
  'savePct',
  'faceoffPct',
]

export const PLAYER_STATS_URL = `https://stats.${MAIN_PLL_URL}/players`
